import * as queries from 'lib/graphql/queries';
import storefront from 'lib/storefront';
import { convertGQLToProductJson } from 'utils/general';

export default {
  setProduct({ commit }, payload) {
    commit('setProduct', payload);
  },
  setGWPModal({ commit }, payload) {
    commit('setGWPModal', payload);
  },
  setVariant({ commit }, payload) {
    commit('setVariant', payload);
  },
  fetchMicroCollection(
    { commit },
    { payload, isGWP = false, selectedShades = false },
  ) {
    commit('setLoading', true);
    const handle = payload.replace(/-plus;/g, '');
    return storefront
      .request(queries.collectionWithVariants, { handle })
      .then((response) => {
        const products = response?.collection?.products?.edges;
        if (products) {
          const normalizedProducts = products.map((product) =>
            convertGQLToProductJson(product.node),
          );

          if (isGWP) {
            const filteredGWP = normalizedProducts
              .map((product) => {
                const gwpVariants = product.variants.filter(
                  (variant) => !!variant.isGWPVariant,
                );
                return { ...product, variants: gwpVariants };
              })
              .filter((p) => p.variants.length);

            commit('setMicroCollectionProducts', filteredGWP);
          } else if (selectedShades) {
            // Selected shades for Bundle Builder products
            const filteredProducts = normalizedProducts.reduce(
              (products, product) => {
                if (selectedShades.find((id) => product.id === id)) {
                  products.push(product);
                }
                return products;
              },
              [],
            );
            commit('setMicroCollectionProducts', filteredProducts);
          } else {
            commit('setMicroCollectionProducts', normalizedProducts);
          }
        } else {
          console.log('Could not find collection in Storefront API', payload);
        }
        commit('setLoading', false);
        return Promise.resolve(response);
      })
      .catch((error) => {
        console.error(error);
        commit('setLoading', false);
      });
  },
  checkMicroCollection({ commit }, payload) {
    commit('setLoading', true);
    return storefront
      .request(queries.collectionWithVariants, { handle: payload })
      .then((response) => {
        const products = response?.collection?.products?.edges;
        let existed = false;
        if (products) {
          existed = true;
        }
        commit('setLoading', false);
        return Promise.resolve(existed);
      })
      .catch((error) => {
        console.error(error);
        commit('setLoading', false);
      });
  },
  updateActiveCategory({ commit }, payload) {
    commit('setActiveCategory', payload);
  },
  updateModalTitle({ commit }, payload) {
    commit('setModalTitle', payload);
  },
  updateCtaText({ commit }, payload) {
    commit('setCtaText', payload);
  },
  updateItemToUpdate({ commit }, payload) {
    commit('setItemToUpdate', payload);
  },
  updateAction({ commit }, payload) {
    commit('setAction', payload);
  },
};
